import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Phone, ArrowRight } from 'lucide-react';
import { companyInfo } from '../data';
import ServiceCard from '../components/ServiceCard';
import useDocumentTitle from '../hooks/useDocumentTitle';

export default function Services() {
  useDocumentTitle('Ydelser');
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('https://api.dev.auxo.dk/public/content/ydelser')
      .then((res) => res.json())
      .then((data) => {
        setServices(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error('Error fetching services:', err);
        setLoading(false);
      });
  }, []);

  return (
    <div className="w-full bg-neutral-50 min-h-screen">
      {/* Page Header */}
      <section className="bg-neutral-950 text-white py-16 md:py-20 relative overflow-hidden">
        <div className="absolute inset-0 z-0 opacity-20">
          <img
            src="https://assets.auxodev.dk/assets/58aac8da-8467-43e1-8dec-94cd5cd444a3/f2817f88-668d-44ff-b5eb-5b13aa8116b5.jpg"
            alt="Murerarbejde"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
          <div className="w-16 h-1 bg-red-700 mb-4" />
          <h1 className="text-3xl md:text-5xl font-extrabold tracking-tight">Mine Ydelser</h1>
          <p className="text-neutral-400 text-base md:text-lg mt-2 max-w-xl">
            Jeg udfører alt murerarbejde med fokus på kvalitet, holdbarhed og æstetik. Se mine primære arbejdsområder nedenfor.
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-16 md:py-24 max-w-7xl mx-auto px-4 md:px-6">
        {loading ? (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[1, 2, 3].map((n) => (
              <div key={n} className="animate-pulse bg-white h-96 rounded-sm border border-neutral-200" />
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {services.map((service) => (
              <ServiceCard key={service.id} service={service} />
            ))}
          </div>
        )}

        {/* Custom Work / Info Box */}
        <div className="mt-16 bg-white border border-neutral-200 p-8 md:p-10 rounded-sm shadow-sm flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="max-w-2xl">
            <h3 className="text-xl font-bold text-neutral-950 mb-2">Har du en speciel mureropgave?</h3>
            <p className="text-neutral-600 text-sm leading-relaxed">
              Udover mine primære ydelser udfører jeg også mindre reparationer, flisearbejde på badeværelser, støbning af sokler samt forsikringsskader. Ingen opgave er for lille – kontakt mig for en snak om dit projekt.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-4 flex-shrink-0 w-full md:w-auto">
            <Link
              to="/kontakt"
              className="bg-red-700 hover:bg-red-800 text-white text-xs font-bold uppercase tracking-wider px-6 py-3.5 rounded-sm transition-all duration-200 hover:-translate-y-1 hover:shadow-md text-center shadow-sm"
            >
              Få et tilbud
            </Link>
            <a
              href={`tel:${companyInfo.phone.replace(/\s+/g, '')}`}
              className="border border-neutral-300 hover:bg-neutral-50 text-neutral-800 text-xs font-bold uppercase tracking-wider px-6 py-3.5 rounded-sm transition-all duration-200 hover:-translate-y-1 hover:shadow-md text-center flex items-center justify-center gap-2 shadow-sm"
            >
              <Phone size={14} />
              <span>Ring {companyInfo.phone}</span>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
